import {
  CognitoIdentityProviderClient,
  GetUserCommand
} from "@aws-sdk/client-cognito-identity-provider";
import { fetchAuthSession } from "aws-amplify/auth";
import { Cache } from "aws-amplify/utils";

// enum
import { ENUM_USER_ATTRIBUTES_CACHE_KEY } from "./enum";

// env
const {
  REACT_APP_REGION
} = process.env;

// clients
const idpClient = new CognitoIdentityProviderClient({
  region: REACT_APP_REGION,
});

const getUserCognito = async (accessToken) => {
  const command = new GetUserCommand({
    AccessToken: accessToken
  });

  const res = await idpClient.send(command);
  console.log('services.user.getUserAttributes@getUserCognito', 'res', res);

  // from cognito
  return {
    user_id: res.UserAttributes.find(o => o.Name === 'sub')?.Value,
    name: res.UserAttributes.find(o => o.Name === 'name')?.Value || null,
    email: res.UserAttributes.find(o => o.Name === 'email')?.Value || null,
    picture: JSON.parse(res.UserAttributes.find(o => o.Name === 'picture')?.Value || null),
    phone_number: res.UserAttributes.find(o => o.Name === 'phone_number')?.Value || null,
    last_synced: new Date().toISOString(),
  }
}

const handler = async (payload, { getState, rejectWithValue }) => {
  try {
    // get credentials
    const { tokens } = await fetchAuthSession();

    const user = await getUserCognito(tokens.accessToken.toString());

    // save to local cached
    // await Cache.setItem(ENUM_USER_ATTRIBUTES_CACHE_KEY, user);

    return user;

  } catch (error) {
    console.error('services.user.getUserAttributes@handler', error);
    return rejectWithValue(error);
  }
}

const pending = (state, action) => {
  return {
    ...state,
    initialized: false,
  };
}

const fulfilled = (state, action) => {
  return {
    ...state,
    ...action.payload,
    initialized: true,
  };
}

const rejected = (state, action) => {
  return {
    ...state,
    initialized: false,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}